export default __webpack_public_path__ + "static/media/arrow-right-blue.ba703e33.svg";